import { ParentContext } from 'global/cnr/contexts/ParentContext'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useTeamRosters } from 'projectSpecific/sports/useHelpers/useTeamRosters'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'

export const TeamMatchRoster = ({ handleCancel }) => {

  const { filterRosters, updating: updating_roster, allowRosterUpdate, getTeamRosters, updateRoster, getRosters, getStaff } = useTeamRosters()

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { teams_info, roster_info, currentSeason_info } = sportsSeason_state ?? {}
  const { currentSeason } = currentSeason_info ?? {}
  const { teams } = teams_info ?? {}
  const { rosters: rosters_sport } = roster_info ?? {}

  const [selectedTeam, setSelectedTeam] = useState()
  const [currentMatchRoster, setCurrentMatchRoster] = useState()

  const roster_team = useMemo(() => {
    const r = filterRosters({ currentSeason, teamRosters: rosters_sport })
    const rt = r?.[pathViews?.teams]
    const rtm = {}
    _.forEach(rt, (rit, tr) => {
      rtm[tr] = _.omit(rit, ['seasons'])
    })
    return rtm
  }, [rosters_sport])

  useEffect(() => {
    setSelectedTeam(teams?.[pathViews?.teams])
    setCurrentMatchRoster(roster_team)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roster_team]);


  const handleUpdateMatchRoster = () => {
    console.log('currentMatchRoster', currentMatchRoster)
    handleCancel()
  }

  const footer_players_select = () => {
    const btns = []
    btns.push({ caption: 'Save Match Roster', oc: handleUpdateMatchRoster, color: 'green', icon: 'save' })
    return <UiSaveButtons others={btns} />
  }

  const lbl_icn_check = (value, selected, oc, width) => <Label
    size='mini'
    style={{ flex: 1, width: width ? `${width}px` : '40px', textAlign: 'center' }}
    onClick={(e) => { oc(value) }}
  >
    <Icon
      name={selected ? 'check circle outine' : 'circle outline'}
      color={selected ? 'blue' : 'grey'} />
    {_.startCase(value)}
  </Label>

  const fnAlt_player_select = (item) => {
    const oc = (type) => {
      const _currentMatchRoster = _.cloneDeep(currentMatchRoster)
      const player = _currentMatchRoster[item?.playerKey]
      player[type] = !player[type]
      setCurrentMatchRoster(_currentMatchRoster)
    }
    const { varsity, starter } = item ?? {}
    return <div style={{ display: 'flex', columnGap: '.5em', justifyContent: 'space-between', width: '160px', marginTop: '.5em', marginLeft: '3em' }}>
      {lbl_icn_check('varsity', varsity, oc, 60)}
      {lbl_icn_check('starter', starter, oc, 60)}
    </div>
  }

  const ims_players_select = () => {
    return <Wrapper
      header={<div style={{ display: 'flex', justifyContent: 'flex-start', columnGap: '1em' }}>
        <div><Icon name={'arrow left'} onClick={(e) => { handleCancel() }} /></div>
        <div>{`${selectedTeam?.name} Match Roster`}</div>
      </div>}
      content={<ItemMenuSquares
        imsType={_imsTypes.inline}
        menuItems={_.sortBy(currentMatchRoster, 'lastName')}
        fn_altContent={fnAlt_player_select}
        noItemIcon={true}
        iconItem={'user'}
      />}
      wrapperType={wrapperTypes.padded}
      footer={footer_players_select()}
    ></Wrapper>
  }

  return ims_players_select()
}
